// NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./NotFound.css";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Página no encontrada (404) | Wayo</title>
        <meta name="description" content="Página no encontrada. La página que buscas no existe o ha sido movida." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://wayoai.app/404" />
      </Helmet>

      <main className="notfound-page">
        <div className="notfound-container">
          <div className="notfound-content">
            <div className="notfound-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            
            <h1 className="notfound-title">404</h1>
            <h2 className="notfound-subtitle">Página no encontrada</h2>
            <p className="notfound-text">
              Lo sentimos, la página que buscas no existe o ha sido movida.
            </p>

            <div className="notfound-buttons">
              <Link to="/" className="notfound-btn-primary">
                🏠 Volver al inicio
              </Link>
              <Link to="/blog" className="notfound-btn-secondary">
                📝 Ver el blog
              </Link>
            </div>
          </div>

          <div className="notfound-footer">
            <p>¿Necesitas ayuda? <Link to="/contact">Contáctanos</Link></p>
          </div>
        </div>
      </main>
    </>
  );
}
